export const sumArray = arr=> (arr.reduce((previousValue, currentValue) => previousValue + currentValue,0));